export default "__VITE_ASSET__DrK3bshN__"